/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_Event_DeletedInputs */



/**
* | output |
* | --- |
* | "No event (deleted)" |
*
* @param {Compare_Event_Groups_No_Event_DeletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_event_deleted = /** @type {((inputs?: Compare_Event_Groups_No_Event_DeletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_Event_DeletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement (supprimé)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Ereignis (gelöscht)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento (eliminato)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событий нет (удалено)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin evento (eliminado)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无事件（已删除）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントなし（削除済み）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई घटना नहीं (हटा दी गई)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento (excluído)")
	return /** @type {LocalizedString} */ ("No event (deleted)")
});